(function(){
  $('.js-new-theme-form').submit(function(e){
    e.preventDefault();
    $btn = $(this).find('.n__new__theme__submit');
    $btn.prop('disabled', true);
    $self = $(this);
    $.ajax({
      type: "POST",
      dataType : "json",
      url: $self.attr('action'),
      data: {
        action: "n_new_theme_form",
        theme: $self.find('[name="theme"]').val(),
        name: $self.find('[name="name"]').val()
      },
      success: (res) => {
        console.log(res);
        $self.find('.row').html(`<div class="col-12">${res.data.text}</div>`);
      },
      error: (err) => {
        console.log(err);
        alert('Atsiprašome, įvyko klaida...');
      }
    });
  });
})();